import React from "react";
import {
  Button,
  Card,
  Form,
  Col,
  Modal,
  Row,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { Label } from "reactstrap";
import { Document, Page, pdfjs } from "react-pdf";
import { showUrlDokumen } from "stores/Pengajuan/function";
// import "react-pdf/dist/esm/Page/AnnotationLayer.css";
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function Step6() {
  const dispatch = useDispatch();
  const pengajuan = useSelector((state) => state.pengajuanReducer);
  const valDetail = !pengajuan.detailPengajuan.stepEnam
    ? []
    : pengajuan.detailPengajuan.stepEnam;
  // console.log(valDetail, "PPPPP");
  const [listUrlDokumen, setListUrlDokumen] = React.useState([]);
  const statusDokumen = pengajuan.listPengajuanById.statusDokumen;

  const handleClickPdf = (url) => {
    dispatch({
      type: "PREVIEW_DOKUMEN",
      data: showUrlDokumen(dispatch, { urlImage: url }),
    });
  };

  React.useEffect(() => {
    let tmp = [];

    Object.entries(valDetail).forEach(([key, value]) => {
      // console.log(key, value, "QQSWQWAQQS");
      if (
        key !== "_id" &&
        key !== "id_pinjaman" &&
        key !== "createdAt" &&
        key !== "updatedAt"
      ) {
        const statusValue = statusDokumen ? statusDokumen[key] : null;

        tmp.push({
          key: key,
          url: value,
          status: statusValue,
        });
      }
    });

    // console.log(tmp, "Merged Object");
    setListUrlDokumen(tmp);
  }, [valDetail, statusDokumen]);

  // React.useEffect(() => {
  //   let tmp = [];
  //   let tmpStatusDokumen = [];
  //   Object.entries(valDetail).forEach(([key, value]) => {
  //     if (
  //       key != "_id" &&
  //       key != "id_pinjaman" &&
  //       key != "createdAt" &&
  //       key != "updatedAt"
  //     ) {
  //       const arrayStatusDokumen = Object.entries(statusDokumen);
  //       console.log(arrayStatusDokumen, " ARRAY STATUS");
  //       const foundArrayStatusDokumen = arrayStatusDokumen.find(
  //         ([keyStatusDokumen]) => {
  //           console.log(keyStatusDokumen, "KEY STATUS");
  //           keyStatusDokumen === "buku_nikah";
  //         }
  //       );
  //       if (foundArrayStatusDokumen) {
  //         const [keyValue] = foundArrayStatusDokumen;
  //         console.log(keyValue, "KEY VALUE");
  //         console.log(foundArrayStatusDokumen, "FOUND ARRAy");
  //       }
  //       tmp.push({
  //         key: key,
  //         url: value,
  //       });
  //     }
  //   });
  //   console.log(tmp, "QQQ");
  //   setListUrlDokumen(tmp);
  // }, []);

  return (
    <div className="mt-4">
      <h4
        style={{
          fontWeight: "800",
          textTransform: "uppercase",
          color: "#2C3E50",
          fontSize: "18px",
          marginBottom: "20px",
          paddingBottom: "12px",
          borderBottom: "2px solid #f0f0f0"
        }}
      >
        Dokumen PDF
      </h4>
      <div style={{ maxHeight: "550px", overflowY: "auto", overflowX: "hidden", padding: "5px" }}>
        <Row>
          {listUrlDokumen.map((val, index) => (
            <Col xs={12} md={6} lg={4} key={index} className="mb-3">
              <div
                style={{
                  padding: "16px 20px",
                  backgroundColor: "#F8FAFC",
                  borderRadius: "14px",
                  height: "100%",
                  border: "1px solid #E2E8F0",
                  transition: "all 0.3s ease",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#F0F9FF";
                  e.currentTarget.style.boxShadow = "0 6px 16px rgba(14, 165, 233, 0.12)";
                  e.currentTarget.style.transform = "translateY(-3px)";
                  e.currentTarget.style.borderColor = "#BAE6FD";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#F8FAFC";
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.borderColor = "#E2E8F0";
                }}
              >
                <div>
                  <div
                    style={{
                      fontSize: "13px",
                      fontWeight: "700",
                      color: "#64748B",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      marginBottom: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between"
                    }}
                  >
                    <span>{val.key.replace(/_/g, " ")}</span>
                    {val.status?.statusKirim === 1 && (
                      <i className="fas fa-check-circle" style={{ color: "#10B981", fontSize: "16px" }}></i>
                    )}
                    {val.status?.statusKirim !== 1 && val.status?.statusKirim !== 0 && val.status && (
                      <i className="far fa-times-circle" style={{ color: "#EF4444", fontSize: "16px" }}></i>
                    )}
                  </div>

                  <div style={{ display: "flex", alignItems: "center", marginBottom: "15px" }}>
                    <i className="far fa-file-pdf" style={{ fontSize: "28px", color: "#EF4444", marginRight: "12px" }}></i>
                    <div style={{
                      fontSize: "12px",
                      color: "#3B82F6",
                      wordBreak: "break-all",
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden"
                    }}>
                      {val.url}
                    </div>
                  </div>
                </div>

                <Button
                  onClick={() => handleClickPdf(val.url)}
                  style={{
                    width: "100%",
                    backgroundColor: "#0EA5E9",
                    border: "none",
                    borderRadius: "8px",
                    padding: "8px",
                    fontWeight: "600",
                    fontSize: "14px",
                    boxShadow: "0 2px 4px rgba(14, 165, 233, 0.2)"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#0284C7"}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#0EA5E9"}
                >
                  <i className="fas fa-eye" style={{ marginRight: "8px" }}></i>
                  Lihat Dokumen
                </Button>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
}
export default Step6;
